<template>
  <v-footer color="primary" class="mb-0">
   <v-container>
      <v-card color="primary" class="flex container" flat tile>
      <v-row class="container">
        <v-col cols="12" md="4" lg="4">
          <h4 class="my-3">ABOUT US</h4>
          <ul>
            <li >
             <router-link class="white--text" to="/terms-of-use">
              Terms of Use
             </router-link>

            </li>

            <li>
              <router-link class="white--text" to="/privacy-policy">
              Privacy Policy
              </router-link>
            </li>
          </ul>
        </v-col>
        <v-col cols="12" md="4" lg="4">
          <h4 class="my-3">BLOG</h4>
          <ul>
            <li>
              <router-link class="white--text" to="/blog-guidelines">
                GuideLines
              </router-link>
            </li>
          </ul>

          <ul>
            <li>
              <router-link class="white--text" to="/blogs">
              All Blogs
              </router-link>
            </li>
          </ul>
        </v-col>
        <v-col cols="12" md="4" lg="4">   
            <h4 class="my-3">CONTACT US</h4>
            <div>
            <v-row>
              <v-col cols="2">
                <v-icon color="white">
                  mdi-email
                </v-icon>
              </v-col>
              <v-col class="white--text" cols="10">
                <a class="white--text" href="mailto:info&commat;guiomentor&period;com">info&commat;guiomentor&period;com</a>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="2">
                <v-icon color="white">
                  mdi-linkedin
                </v-icon>
              </v-col>
              <v-col cols="10">
                <a class="white--text" href="https://www.linkedin.com/company/guiomentor" target="_blank">Linkedin</a>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="2">
                <v-icon color="white">
                  mdi-facebook
                </v-icon>
              </v-col>
              <v-col cols="10">
                <a class="white--text" href="https://www.facebook.com/Guiomentor/?ref=py_c" target="_blank">Facebook</a>
              </v-col>
            </v-row>
          </div>
        </v-col>
      </v-row>

      <v-card-text
          class="py-2 white--text text-center"
          :style="{marginBottom: $vuetify.breakpoint.smAndDown? '3em' : '1em'}"
      >
        {{ new Date().getFullYear() }} — <strong>Guiomentor</strong>
      </v-card-text>
    </v-card>
   </v-container>
  </v-footer>
</template>

<script>
export default {
  name: "Footer",
  data: () => ({
    icons: ["mdi-facebook", "mdi-twitter", "mdi-linkedin", "mdi-instagram"],
  }),
};
</script>

<style scoped>
*{
  color: white;
}

ul{
  padding: 0;
  margin: 0;
  list-style: none;
}

li {
  margin: 0.6rem 0;
  text-decoration: underline;
  cursor: pointer;
}

</style>
